module.exports = __webpack_public_path__ + "static/media/Kiosk-Screen6.6b662ab8.png";